import * as React from 'react';
import ImageUploader from 'react-images-upload';
import {config} from "config";

interface ImageFieldProps {
    onChange;
    invalid;
    name;
    type?;
    value?;
    defaultPreview?;
}

export const ImageField = (props: ImageFieldProps) => {
    return <>
        { props.defaultPreview && (
            <div>
                <img alt={``} src={props.defaultPreview} className={'uploaded-image-preview'} width={120} />
            </div>
        ) }

        <ImageUploader
            withIcon={true}
            buttonText='Choose image'
            withPreview={true}
            onChange={async data => {
                const formData = new FormData();
                formData.append('image', data[0]);

                const result = await fetch(config.backendBase + '/uploader', {
                    method: 'POST',
                    headers: {},
                    body: formData,
                });

                const json = await result.json();
                props.onChange(json.id);
            }}
            defaultImage={props.defaultPreview}
            singleImage={true}
            imgExtension={['.jpg', '.gif', '.png', '.gif']}
            maxFileSize={5242880}
        />
    </>
};
